const initialState = {
    screen: 'mobile',
    type: 'mobile',
    width: 480,
    scroll: 0,
};

export default function display(state = initialState, action) {
    switch ( action.type ) {
        case 'UPDATE_DISPLAY_STATE':
            var data = action.data;

            var width = data.width;
            if( width ) {
                data.screen = width <= 480 ? 'mobile' : width <= 840 ? 'tablet' : 'desktop';
                data.type = width <= 480 ? 'mobile' : width <= 840 ? 'tablet' : 'desktop';
            }
            return {
                ...state,
                ...data,
            };
        default:
            return state;
    }
}
